const getters = {
  alert_banner_channel: (state) => state.alert_banner_channel,
}

export default getters
